import api from '@/api/api.js'

// Configuration de la clinique (nom, logo, devise…), redemandée par le routeur à chaque changement de page
// (05/10/2026) : les appels simultanés partagent la requête et la réponse sert 60 s par type. La Caisse ne modifie
// pas ces réglages (ils se règlent dans la Clinique) : un changement y apparaît au plus 60 s plus tard.
const CONFIG_CLINIQUE_MS = 60000
const configsClinique = {}

export default {
    getInfoSFE(data){
        const promise = api.comptabilite().post('/sfe/info_sfe', data)
        return promise.then(response => response.data)
    },

    getConfigInfoClinique(data){
        const actuelle = configsClinique[data]
        if (!actuelle || (actuelle.recu && Date.now() - actuelle.recu >= CONFIG_CLINIQUE_MS)) {
            const entree = { recu: 0 }
            entree.promesse = api.clinique().get('/config/info_clinique/'+data).then(response => {
                entree.recu = Date.now()
                return response.data
            }, erreur => {
                if (configsClinique[data] === entree) delete configsClinique[data]
                throw erreur
            })
            configsClinique[data] = entree
        }
        return configsClinique[data].promesse.then(donnees => donnees === undefined ? donnees : JSON.parse(JSON.stringify(donnees)))
    },

    getCoupureBilletage(data_type){
        const promise = api.clinique().get('/config/coupure-billetage/'+data_type)
        return promise.then(response => response.data)
    },

    saveCustomExclusion(data) {
        const promise = api.comptabilite().post('/custom-exclusions/store', data)
        return promise.then((response) => response.data)
    },

    selectCustomExclusions() {
        const promise = api.comptabilite().get('/custom-exclusions/liste')
        return promise.then((response) => response.data)
    },
}